import ssoAcceptBR from './ssoAccept.br';
import ssoAcceptCL from './ssoAccept.cl';
import ssoAcceptCO from './ssoAccept.co';
import ssoAcceptMX from './ssoAccept.mx';

const ssoAccept = {
  BR: ssoAcceptBR,
  CL: ssoAcceptCL,
  CO: ssoAcceptCO,
  MX: ssoAcceptMX,
};

export default ssoAccept;
